import React, { useContext, useEffect, useState } from "react";
import { Button } from "@mui/material";
import Context from "../../../../context/Context";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { WsEvents, useWebsocket } from "../../../../context/hooks/WebSocket";
import './styles.css';
import toast from "react-hot-toast";
import blogFetch from "../../../../axios/config";
import { AnaliseModalObs } from "../AnaliseModalObs";
import Loading from "../../../../components/Loading";
import { Modal } from 'react-bootstrap';
import { InputGroup, Form } from "react-bootstrap";


export const WagonApprovedCardsFinalizado = ({
  status,
  //confirmedWagon
}) => {

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [currentVagaoKey, setCurrentVagaoKey] = useState();
  const [currentItemKey, setCurrentItemKey] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [showObs, setShowObs] = useState(false)
  const [confirmedWagonList, setConfirmedWagonList] = useState()
  const [confirmedWagon, setConfirmedWagon] = useState([])
  const [filterValue, setFilterValue] = useState('');

  const handleClose = () => setShowModal(false);

  const {
    selectedFurnace,
    loading,
  } = useContext(Context);

  useEffect(() => {
    if (status && selectedFurnace)
      getConfirmedWagon(status, selectedFurnace)
  }, [status, selectedFurnace]);

  const getConfirmedWagon = async (status, selectedFurnace) => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_VagoesFornosPecas?status=${status}&furnace=${selectedFurnace}`);

      const url = data.map((item) => {
        if (item.wagonInfo.vagao_Image)
          item.wagonInfo.vagao_Image += "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-06-06T23:22:22Z&st=2023-06-06T15:22:22Z&spr=https,http&sig=AmNdgNEWKNvsjgz%2BfwYJKb7l1nBWV%2F5V34UqWHQ0n%2FY%3D"
        return item
      })

      const result = relacionarPecasEMoldes(url);
      setConfirmedWagonList(result);
      setConfirmedWagon(url);
    } catch {
      console.error("Error")
    }
    
  }


  const getUserMatricula = () => {
    const nro_matricula = JSON.parse(localStorage.getItem('user'))
    const userSAPMatricula = nro_matricula['user_SAPMatricula'];
    return userSAPMatricula
  }

  const FormatVagaoKey = (clickedItem) => {
    return parseInt(clickedItem.vagao_Serial.substring(1), 10);
  };
  

  const modalObs = (item, itemkey, Vagaokey) => {
    setCurrentItem(item);
    setCurrentItemKey(itemkey);
    setCurrentVagaoKey(Vagaokey)
    setShowObs(true);
  }

  const AprovaPeca = async (item, Vagaokey, itemkey) => {
    console.log('AprovaPeca');
    console.log(item, Vagaokey, itemkey);    
    
    await removeItem(Vagaokey, itemkey);
    await checkPartLab(item.ordem_CodMaterial)
    try {
      await postAprovadoApontamento(item)
      await putAprovadoPeca(item)
      await putAprovadoVagao(item)
      toast.success(`Ordem ${item.ordem_Serial} apontada com sucesso`, {
        duration: 4000
      })
    } catch (e) {
      console.error(e)
      toast.error(`Erro ao apontar ordem ${item.ordem_Serial} `, {
        duration: 4000
      })
      await getConfirmedWagon(status, selectedFurnace)
    } finally {
    }
  }

  const relacionarPecasEMoldes = (confirmedWagon) => {
    let resultadoPorVagaoKey = {};

    confirmedWagon.forEach((wagon, index) => {
      wagon.wagon.forEach((wagonItem) => {
        wagon.wagonInfo.isagA_Vagoes_Fornos_Pecas
          .filter(isagA_Vagoes_Fornos_Peca => isagA_Vagoes_Fornos_Peca.status_Peca === "FINALIZADO")
          .forEach((isagA_Vagoes_Fornos_Peca) => {
            if (wagonItem.ordem_Serial === isagA_Vagoes_Fornos_Peca.ordem_Serial) {
              const vagaoKey = wagon.wagonInfo.vagao_Key;
              if (!resultadoPorVagaoKey[vagaoKey]) {
                resultadoPorVagaoKey[vagaoKey] = [];
              }
              resultadoPorVagaoKey[vagaoKey].push({
                rack_Buffer: wagonItem.rack_Buffer,
                bomba_A: wagonItem.bomba_A,
                bomba_B: wagonItem.bomba_B,
                bomba_C: wagonItem.bomba_C,
                comb_Nome: wagon.tipoCombinacaoPeca.comb_Nome,
                forno: wagon.tipoCombinacaoPeca.forno,
                image: wagon.wagonInfo.vagao_Image,
                m2_Peca: wagonItem.m2_Peca,
                molde_Codigo: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Codigo,
                molde_Descricao: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Descricao,
                molde_Key: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Key,
                molde_Lote: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Lote,
                molde_QtdPassagens: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_QtdPassagens,
                ordem_Part_Short: wagonItem.ordem_Part_Short,
                ordem_Serial: wagonItem.ordem_Serial,
                ordem_VehCod: wagonItem.ordem_VehCod,
                ordem_VehDesc: wagonItem.ordem_VehDesc,
                ordem_CodMaterial: wagonItem.ordem_CodMaterial,
                status_Molde: isagA_Vagoes_Fornos_Peca.status_Molde,
                status_Peca: isagA_Vagoes_Fornos_Peca.status_Peca,
                subProduto_Desc: wagonItem.subProduto_Desc,
                vagao_Serial: wagon.wagonInfo.vagao_Serial,
              });
            }
          });
      });
    });

    const resultado = Object.values(resultadoPorVagaoKey);

    return resultado;
  };

  const putAnalisePeca = async (item, obs, Vagaokey, itemkey) => {

    await removeItem(Vagaokey, itemkey)
    await checkPartLab(item.ordem_CodMaterial)
    try {
      await blogFetch.put(`/ISAGA_VagoesFornosPecas`, {
        Vagao_Key: FormatVagaoKey(item),
        Ordem_Serial: item.ordem_Serial,
        Status: "ANALISE",
        Molde_Key: item.molde_Key,
        Status_Peca: "ANALISE",
        Observacao: obs
      });
      await putAprovadoVagao(item)
      toast.success("Sucesso ao adicionar peça em análise", {
        duration: 4000,
      });
    } catch (e) {
      console.error(e)
      toast.error("Erro ao adicionar peça em análise", {
        duration: 4000,
      });
      await getConfirmedWagon(status, selectedFurnace)
    } finally {
      setShowObs(false)
    }
  }

  const putAprovadoPeca = async (item) => {
    try {
      await blogFetch.put(`/ISAGA_VagoesFornosPecas`, {
        Vagao_Key: FormatVagaoKey(item),
        Ordem_Serial: item.ordem_Serial,
        Status: "APROVADO",
        Molde_Key: item.molde_Key,
        Status_Peca: "APROVADO"
      });
    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  const postAprovadoApontamento = async (item) => {
    const userSAPMatricula = getUserMatricula();
    try {
      await blogFetch.post(`ISAGA_ApontamentoSAP?furnace=${selectedFurnace}`, {
        Centro_Trabalho: "06CURVAD",
        Ordem_Fabricacao: item.ordem_Serial,
        Operacao: "1000",
        Tipo_Apontamento: "APROVADO",
        Chave_Modelo: "SALH",
        Nro_Matricula: userSAPMatricula
      })
    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  const putAprovadoVagao = async (item) => {
    const Vagao_Key = FormatVagaoKey(item)
    try {
      await blogFetch.put(`/ISAGA_VagoesFornos/aprovado`, {
        Vagao_Key: Vagao_Key
      })
    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  console.log(confirmedWagon, 'confirmedWagon1');
  console.log(confirmedWagonList, 'confirmedWagonList1');
  
  

  const removeItem = async (Vagaokey, itemkey) => {
    console.log(Vagaokey, itemkey, 'VagaoKey,itemKey');    
    console.log(confirmedWagon, 'confirmedWagon');
    
    const updatedList = confirmedWagonList.map((Vagao, idx) => {
      if (idx === Vagaokey) {
        return Vagao.filter((_, i) => i !== itemkey);
      }
      return Vagao;
    }).filter(Vagao => Vagao.length > 0);



    setConfirmedWagonList(updatedList);
  };

  const verifyPartLab = async (codMat) => {
    try {
      const data = await blogFetch.post(`ISAGA_VagoesFornosPecas/verify-part-lab`, codMat);
      return data;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const checkPartLab = async (codMat) => {
    const response = await verifyPartLab(codMat);

    if (response.request.status === 200) {
      setModalMessage('Essa peça deve ser levada ao laboratório');
      setShowModal(true);
    }

    return
  };

  const filteredWagonList = (confirmedWagonList || []).map(vagao =>
    vagao.filter(item =>
      item.ordem_Serial.toString().toLowerCase().includes(filterValue.toLowerCase()) ||
      item.vagao_Serial.toString().toLowerCase().includes(filterValue.toLowerCase())
    )
  );

  return (
    <div>
      {/* <input
        type="text"
        placeholder="Filtrar..."
        value={filterValue}
        onChange={handleInputChange}
      /> */}
      <InputGroup>
        <Form.Control
          placeholder="Buscar Peça - Ordem serial ou Vagão Serial"
          value={filterValue}
          onChange={({ target }) => setFilterValue(target.value)}
        />
      </InputGroup>
      {!loading ?
        <div>
          {confirmedWagonList  && (
            <div className="table-container">
              <table className="tableFixHead table text-center">
                <thead>
                  <tr>
                    <th>ORDEM SERIAL</th>
                    <th>VAGÃO SERIAL</th>
                    <th className='hideSmall'>FORNO</th>
                    <th>TIPO PECA</th>
                    <th className='hideSmall'>PRODUTO</th>
                    <th>ORDEM VEHDESC</th>
                    <th className='hideSmall'>M2 PEÇA</th>
                    <th className='hideSmall'>MOLDE CÓDIGO</th>
                    <th className='hideSmall'>MOLDE DESCRIÇÃO</th>
                    {/* <th className='hideSmall'>RACK BUFFER</th> */}
                    <th className='hideSmall'>MOLDE QTD PASSAGEM</th>
                    <th>APROVADO</th>
                    <th>ANÁLISE</th>
                  </tr>
                </thead>

                {filteredWagonList.map((Vagao, Vagaokey) => (
                  <tbody >
                    {Vagao.map((item, itemkey) => (
                      <tr key={`vagaoItens-${Vagaokey}`}>
                        <td>{item.ordem_Serial}</td>
                        <td>{item.vagao_Serial}</td>
                        <td className='hideSmall'>{item.forno}</td>
                        <td>{item.ordem_Part_Short}</td>
                        <td className='hideSmall'>{item.subProduto_Desc}</td>
                        <td>{item.ordem_VehDesc}</td>
                        <td className='hideSmall'>{item.m2_Peca}</td>
                        <td className='hideSmall'>{item.molde_Codigo}</td>
                        <td className='hideSmall'>{item.molde_Descricao}</td>
                        {/* <td className='hideSmall'>{item.rack_Buffer}</td> */}
                        <td className='hideSmall'>{item.molde_QtdPassagens}</td>
                        <td>
                          <Button variant="contained"
                            onClick={() => {
                              AprovaPeca(item, Vagaokey, itemkey)

                            }}
                          >
                            APROVAR
                          </Button>
                        </td>
                        <td>
                          <Button
                            style={{ backgroundColor: 'red', color: 'white' }}
                            variant="contained"
                            onClick={() => modalObs(item, itemkey, Vagaokey)}
                          >
                            ANÁLISE
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ))}
              </table>
            </div>
          )}
          {showObs && (
            <AnaliseModalObs
              showObs={showObs}
              item={currentItem}
              itemkey={currentItemKey}
              Vagaokey={currentVagaoKey}
              putAnalisePeca={putAnalisePeca}
              setShowObs={setShowObs}
            />
          )}
        </div>
        : (<Loading />)}


      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Aviso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h2>{modalMessage}</h2>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}